/**
 * Aide contextuelle — accueil de pilotage du dirigeant.
 */

const pilotageHelp = {
  '/pilotage': {
    title: 'Accueil de pilotage',
    user: [
      {
        heading: 'À quoi sert cette page ?',
        content: `C'est ton accueil : une carte par sujet que toi seul peux traiter. Chaque carte dit **quand tu y as touché pour la dernière fois** et **ce qui est apparu depuis**.`,
      },
      {
        heading: 'Les couleurs',
        content: `**Rouge** — en retard sur le rythme de la carte, ou une urgence est dedans.\n**Orange** — à faire aujourd'hui, ou une urgence est apparue depuis ton dernier tour.\n**Vert** — à jour.\n**Gris hachuré** — lecture impossible : la carte n'a pas pu lire sa source. Elle affiche le dernier chiffre connu, jamais du vert.\n**« au moins N » et « lecture partielle »** — une partie de la carte n'a pas pu être lue (Odoo, un dépôt de la VM…) : le reste est compté, la raison est écrite, et la carte n'est jamais verte tant que la partie manque.`,
      },
      {
        heading: 'Dernier geste et dernier tour',
        content: `Le **dernier geste** est mesuré tout seul (une relance écrite, un appel classé…). Le **dernier tour**, c'est toi qui le déclares avec **J'ai fait le tour** quand tu as regardé et qu'il n'y avait rien à faire. Le bouton ne fait pas disparaître ce qui attend : le compteur reste.`,
      },
      {
        heading: 'La liste du jour',
        content: `L'**épingle** d'une carte ou d'une ligne l'ajoute à ta liste du jour, en haut. Une ligne se raye quand elle est traitée. La liste se vide chaque nuit ; rien n'est perdu, tout reste dans les cartes.`,
      },
      {
        heading: 'Le rythme',
        content: `Clique sur le rythme sous le nom d'une carte (« tous les jours », « le jeudi »…) pour le changer : tous les jours, certains jours de la semaine, ou certains jours du mois. La carte change alors de groupe.`,
      },
      {
        heading: 'Les montants',
        content: `Les montants ne sont pas affichés tant que tu n'as pas cliqué sur **Afficher les montants** : l'écran peut être montré sans crainte.`,
      },
    ],
    admin: [],
  },
};

export default pilotageHelp;
